import type {
  PerformancePage,
  PerformancePageOverview,
} from 'api/new-analytics/types';
import BlockGrid from 'app/components/BlockGrid';
import { REPORT_PREVIEW_CHART_GRID_GAP_PX } from 'app/modules/analytics/modules/reports/constants/reportPreviewChartLayout';
import ReportPreviewMetricChart from './ReportPreviewMetricChart';

interface Props {
  chartMetrics: string[];
  pages: PerformancePage[];
  overview: PerformancePageOverview | undefined;
  isLoading: boolean;
}

const ReportPreviewMetricCharts = ({
  chartMetrics,
  pages,
  overview,
  isLoading,
}: Props) => {
  if (chartMetrics.length === 0) {
    return null;
  }

  return (
    <div>
      <BlockGrid columns={1} gap={REPORT_PREVIEW_CHART_GRID_GAP_PX}>
        {chartMetrics.map((metricKey) => (
          <div
            key={metricKey}
            style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}
          >
            <ReportPreviewMetricChart
              metricKey={metricKey}
              pages={pages}
              overview={overview}
              isLoading={isLoading}
            />
          </div>
        ))}
      </BlockGrid>
    </div>
  );
};

export default ReportPreviewMetricCharts;
